import type { ShoppingCategory } from "@recipevault/shared";

/**
 * Human-readable labels for `SHOPPING_CATEGORIES`. Shared by `ShoppingListDetail`
 * (category group headers) and `EditItemSheet` (category `Select`) — pulled out to
 * its own module so both can import it without a circular dependency between the
 * two feature components.
 */
export const CATEGORY_LABELS: Record<ShoppingCategory, string> = {
  produce: "Produce",
  "meat-seafood": "Meat & Seafood",
  "dairy-eggs": "Dairy & Eggs",
  bakery: "Bakery",
  pantry: "Pantry",
  frozen: "Frozen",
  beverages: "Beverages",
  household: "Household",
  other: "Other",
};
